import React, { useEffect, useState } from "react";
import useChatFilter from "../StatesStore/ChatFilter";

const ChatFilter = () => {
  const { chatFilterType, setChatFilterType } = useChatFilter();
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);

  useEffect(() => {
    setChatFilterType("all");
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const PillOption = (type, text) => {
    return (
      <div
        className={`btn px-3 py-1 py-lg-2 badge rounded-pill ${
          chatFilterType === type ? "pillSelected" : "pillNotSelected"
        }`}
        onClick={(e) => {
          e.stopPropagation();
          setChatFilterType(type);
        }}
      >
        {text}
      </div>
    );
  };
  return (
    <>
      <style jsx>
        {`
          .secondHeader3 ul .btn {
            line-height: 1.8 !important;
          }
          .pillSelected {
            color: #fff !important;
            background-color: RGBA(
              20,
              25,
              30,
              var(--bs-bg-opacity, 1)
            ) !important;
          }
          .pillNotSelected {
            color: #000 !important;
            background-color: RGBA(
              238,
              240,
              242,
              var(--bs-bg-opacity, 1)
            ) !important;
          }
          [data-bs-theme="dark"] .pillSelected {
            color: #000 !important;
            background-color: RGBA(
              238,
              240,
              242,
              var(--bs-bg-opacity, 1)
            ) !important;
          }
          [data-bs-theme="dark"] .pillNotSelected {
            color: #fff !important;
            background-color: RGBA(
              20,
              25,
              30,
              var(--bs-bg-opacity, 1)
            ) !important;
          }
        `}
      </style>

      <div
        className="container d-flex mx-0 align-items-center mb-0 hiddenScrollbar py-2 bg-mode gap-3 shadow-sm"
        style={{
          top: 0,
          overflowX: "auto",
          whiteSpace: "nowrap",
          marginTop: isSmallScreen ? "48px" : "0",
          paddingLeft: "20px",
          // width: "24rem",
        }}
      >
        {PillOption("all", "All")}
        {PillOption("unread", "Unread")}
        {PillOption("shoppingList", "List")}
        {PillOption("invitedShoppingList", "Invited Lists")}
        {PillOption("archived", "Archived")}
      </div>
    </>
  );
};

export default ChatFilter;
